// Field arrays for per-sheet field-level configuration in Universe exports.
// Ported from OppGen exportConfigurationFields.ts — framework-agnostic {value, label} arrays.

export type ExportFieldOption = { value: string; label: string };

export const firmographicsExportFields: ExportFieldOption[] = [
  { value: "duns_id", label: "DUNS" },
  { value: "company_level", label: "Company Level" },
  { value: "hierarchy_tier_label", label: "Hierarchy Tier" },
  { value: "address_line_1", label: "Address line 1" },
  { value: "address_line_2", label: "Address line 2" },
  { value: "city_name", label: "City" },
  { value: "state_name", label: "State" },
  { value: "postal_code", label: "Postal Code" },
  { value: "country_id", label: "Country ID" },
  { value: "country_name", label: "Country" },
  { value: "subcontinent_name", label: "Subcontinent" },
  { value: "continent_name", label: "Continent" },
  { value: "geopolitical_name", label: "Geopolitical Name" },
  { value: "latitude_num", label: "Latitude" },
  { value: "longitude_num", label: "Longitude" },
  { value: "industry_id", label: "Industry ID" },
  { value: "industry_name", label: "Industry" },
  { value: "naics_code", label: "NAICS Code" },
  { value: "naics_industry", label: "NAICS Industry" },
  { value: "sic_code", label: "SIC Code" },
  { value: "sic_industry", label: "SIC Industry" },
  { value: "revenue_total", label: "Total Revenue" },
  { value: "revenue_band_name", label: "Revenue Band" },
  { value: "relative_revenue", label: "Relative Revenue" },
  { value: "employee_total", label: "Total Employees" },
  { value: "employee_band_name", label: "Employee Band" },
  { value: "relative_employees", label: "Relative Employees" },
  { value: "FORBES_2000_SEQ", label: "Forbes 2000 Ranking" },
  { value: "FORTUNE_500_SEQ", label: "Fortune 500 Ranking" },
  { value: "stock_exchange", label: "Stock Exchange" },
  { value: "stock_ticker", label: "Stock Ticker" },
  { value: "fiscal_year_end_month", label: "Fiscal Year End Month" },
  { value: "company_description", label: "Company Description" },
  { value: "group_hq_company_name", label: "Group HQ Company Name" },
  { value: "group_hq_domain_name", label: "Group HQ Domain Name" },
  {
    value: "group_hq_domain_name_normalized",
    label: "Group HQ Domain Name Normalized",
  },
  { value: "group_hq_company_id", label: "Group HQ HG Company ID" },
  { value: "company_id", label: "HG Company ID" },
  { value: "group_hq_address_line_1", label: "Group HQ Address line 1" },
  { value: "group_hq_address_line_2", label: "Group HQ Address line 2" },
  { value: "group_hq_city_name", label: "Group HQ City" },
  { value: "group_hq_state_name", label: "Group HQ State" },
  { value: "group_hq_postal_code", label: "Group HQ Postal Code" },
  { value: "group_hq_country_id", label: "Group HQ Country ID" },
  { value: "group_hq_country_name", label: "Group HQ Country" },
  { value: "group_hq_subcontinent_name", label: "Group HQ Subcontinent" },
  { value: "group_hq_continent_name", label: "Group HQ Continent" },
  { value: "group_hq_geopolitical_name", label: "Group HQ Geopolitical Name" },
  { value: "group_hq_latitude_num", label: "Group HQ Latitude" },
  { value: "group_hq_longitude_num", label: "Group HQ Longitude" },
  { value: "group_hq_employee_total", label: "Group HQ Total Employees" },
  { value: "group_hq_employee_band_name", label: "Group HQ Employee Band" },
  { value: "group_hq_revenue_total", label: "Group HQ Total Revenue" },
  { value: "group_hq_revenue_band_name", label: "Group HQ Revenue Band" },
  { value: "group_hq_industry_id", label: "Group HQ Industry ID" },
  { value: "group_hq_industry_name", label: "Group HQ Industry" },
  { value: "group_hq_naics_code", label: "Group HQ NAICS Code" },
  { value: "group_hq_naics_industry", label: "Group HQ NAICS Industry" },
  { value: "group_hq_sic_code", label: "Group HQ SIC Code" },
  { value: "group_hq_sic_industry", label: "Group HQ SIC Industry" },
  { value: "group_hq_forbes_2000_seq", label: "Group HQ Forbes 2000 Ranking" },
  { value: "group_hq_fortune_500_seq", label: "Group HQ Fortune 500 Ranking" },
  { value: "group_hq_stock_exchange", label: "Group HQ Stock Exchange" },
  { value: "group_hq_stock_ticker", label: "Group HQ Stock Ticker" },
  {
    value: "global_hq_fiscal_year_end_month",
    label: "Group HQ Fiscal Year End Month",
  },
  { value: "corporate_parent_name", label: "Corporate Parent Company Name" },
  { value: "corporate_parent_id", label: "Corporate Parent HG Company ID" },
  { value: "domestic_parent_name", label: "Domestic Parent Company Name" },
  { value: "domestic_parent_id", label: "Domestic Parent HG Company ID" },
];

export const installExportFields: ExportFieldOption[] = [
  { value: "company_group_id", label: "Company Group ID" },
  { value: "product_name", label: "Product Name" },
  { value: "product_id", label: "Product ID" },
  { value: "product_description", label: "Product Description" },
  { value: "vendor_name", label: "Vendor Name" },
  { value: "vendor_domain", label: "Vendor URL" },
  { value: "vendor_id", label: "Vendor Id" },
  { value: "vendor_duns_id", label: "Vendor DUNS" },
  { value: "vendor_stock_exchange", label: "Vendor Stock Exchange" },
  { value: "vendor_stock_ticker", label: "Vendor Stock Ticker" },
  { value: "product_category_id", label: "Product Category ID" },
  { value: "product_category_level1_name", label: "Product Category Level 1" },
  { value: "product_category_level2_name", label: "Product Category Level 2" },
  { value: "product_category_level3_name", label: "Product Category Level 3" },
  { value: "product_category_level4_name", label: "Product Category Level 4" },
  { value: "product_category_level5_name", label: "Product Category Level 5" },
  { value: "product_attributes", label: "Product Attributes" },
  { value: "is_on_premise_product", label: "Product On Premise Flag" },
  { value: "is_cloud_product", label: "Product Web Cloud Based Flag" },
  { value: "is_mobile_product", label: "Product Mobile Flag" },
  { value: "product_first_verified_date", label: "Date First Verified" },
  { value: "product_last_verified_date", label: "Date Last Verified" },
  { value: "product_intensity_total", label: "Intensity" },
  { value: "product_locations_total", label: "Locations" },
];

export const mentionExportFields: ExportFieldOption[] = [
  { value: "mention_name", label: "Mention Name" },
  { value: "mention_id", label: "Mention ID" },
  { value: "mention_description", label: "Mention Description" },
  { value: "mention_attributes", label: "Mention Attributes" },
  { value: "mention_first_verified_date", label: "Date First Verified" },
  { value: "mention_last_verified_date", label: "Date Last Verified" },
  { value: "mention_intensity_total", label: "Intensity" },
  { value: "mention_locations_total", label: "Locations" },
];

export const generativeAIExportFields: ExportFieldOption[] = [
  { value: "ai_product_use", label: "AI Product Use" },
  { value: "data_maturity_score", label: "Data Maturity Score" },
  { value: "data_maturity_level", label: "Data Maturity Level" },
  { value: "ai_maturity_6m_delta", label: "AI Maturity 6M Delta" },
  { value: "ai_maturity_score", label: "AI Maturity Score" },
  { value: "company_rank", label: "Company Rank" },
  { value: "cloud_centricity", label: "Cloud Centricity" },
  { value: "gcp_intensity", label: "GCP Intensity" },
  { value: "aws_intensity", label: "AWS Intensity" },
  { value: "azure_intensity", label: "Azure Intensity" },
  { value: "genai_intent_score", label: "GenAI Intent Score" },
  { value: "company_group_id", label: "Company Group ID" },
];

export const intentExportFields: ExportFieldOption[] = [
  { value: "intent_signal_url", label: "Intent Signal URL" },
  { value: "intent_topic", label: "Intent Topic" },
  { value: "intent_signal_strength", label: "Intent Signal Strength" },
  { value: "intent_level", label: "Intent Level" },
  { value: "intent_location_strength", label: "Intent Location Strength" },
  { value: "intent_city", label: "Intent City" },
  { value: "intent_state", label: "Intent State" },
  { value: "intent_country", label: "Intent Country" },
  { value: "product_name", label: "Product Name" },
  { value: "product_id", label: "Product ID" },
  { value: "vendor_name", label: "Vendor Name" },
  { value: "vendor_id", label: "Vendor ID" },
  { value: "intent_buyers_journey", label: "Intent Buyers Journey" },
  { value: "intent_datestamp", label: "Intent Datestamp" },
  { value: "intent_context", label: "Intent Context" },
  { value: "intent_disposition", label: "Intent Disposition" },
  { value: "intent_trend", label: "Intent Trend" },
  { value: "topic_id", label: "Topic ID" },
];

export const contractExportFields: ExportFieldOption[] = [
  { value: "contract_uuid", label: "Contract UUID" },
  { value: "vendor_id", label: "Vendor ID" },
  { value: "vendor_name", label: "Vendor Name" },
  { value: "vendor_duns_id", label: "Vendor DUNS" },
  { value: "vendor_role", label: "Vendor Role" },
  { value: "percent", label: "Percent" },
  { value: "service_line_parent", label: "Service Line Parent" },
  { value: "service_line", label: "Service Line" },
  { value: "geographical_scope", label: "Geographical Scope" },
  { value: "delivery_type", label: "Delivery Type" },
  { value: "signing_country", label: "Signing Country" },
  { value: "announcement_date", label: "Announcement Date" },
  { value: "start_date", label: "Start Date" },
  { value: "end_date", label: "End Date" },
  { value: "active_status", label: "Active Status" },
  { value: "contract_term_months", label: "Contract Term (Months)" },
  { value: "headline", label: "Headline" },
  { value: "description", label: "Description" },
  { value: "total_deal_value", label: "Total Deal Value" },
  { value: "service_line_value", label: "Service Line Value" },
];

export const faiExportFields: ExportFieldOption[] = [
  { value: "company_group_id", label: "Company Group ID" },
  { value: "company_name", label: "Company Name" },
  { value: "url", label: "Domain Name" },
  { value: "url_normalized", label: "Domain Name Normalized" },
  { value: "vendor_name", label: "Vendor Name" },
  { value: "product_id", label: "Product ID" },
  { value: "product_name", label: "Product Name" },
  { value: "area_name", label: "Department" },
  { value: "area_signal_strength", label: "Department Usage Share" },
  { value: "role_name", label: "Role" },
  { value: "role_usage_share", label: "Role Usage Share" },
  { value: "is_decision_maker", label: "Decision Maker Presence @ Location" },
  { value: "is_influencer", label: "Key Influencer Presence @ Location" },
  { value: "country_name", label: "Country" },
  { value: "state_name", label: "State" },
  { value: "city_name", label: "City" },
  { value: "first_verified_at", label: "First Verified" },
  { value: "last_verified_at", label: "Last Verified" },
  { value: "hits_in_area", label: "Signal Strength @ Department" },
  { value: "role_signal_strength_at_location", label: "Signal Share" },
  { value: "signal_strength_at_location", label: "Signal Strength @ Location" },
];

export const contactsExportFields: ExportFieldOption[] = [
  { value: "job_title", label: "Job Title" },
  { value: "job_seniority", label: "Job Seniority" },
  { value: "job_functions", label: "Job Functions" },
  { value: "job_sub_functions", label: "Job Sub-Functions" },
  { value: "employment_start_date", label: "Employment Start Date" },
  { value: "time_in_role_months", label: "Time in Company (Months)" },
  { value: "contact_location_city", label: "City" },
  { value: "contact_location_region", label: "State" },
  { value: "contact_location_country", label: "Country" },
  { value: "contact_location_country_code", label: "Country Code" },
  { value: "first_name", label: "First Name" },
  { value: "last_name", label: "Last Name" },
  { value: "full_name", label: "Full Name" },
  { value: "linkedin_url", label: "LinkedIn URL" },
  { value: "work_email", label: "Work Email" },
  { value: "mobile_phone", label: "Mobile Phone" },
];

// Same list as OppGen's. covered-wagon appends spend_tier itself when SMB
// spend is included and drops fields it doesn't deliver (category_id).
export const rowBasedSpendExportFields: ExportFieldOption[] = [
  { value: "category_id", label: "Category ID" },
  { value: "category_name", label: "Category Name" },
  { value: "category_name_tree", label: "Category Name Tree" },
  { value: "absolute_spend", label: "Absolute Spend" },
  { value: "relative_spend", label: "Relative Spend" },
  { value: "is_leaf_category", label: "Is Leaf Category" },
];

// OppGen's Row-Based Spend sheet starts from this firmographics subset rather
// than the shared default.
export const defaultRowBasedSpendFirmographicsFields: string[] = [
  "COMPANY_NAME",
  "HIERARCHY_TIER",
  "DOMAIN_NAME",
  "DOMAIN_NAME_NORMALIZED",
  "HG_COMPANY_ID",
];

export const contactsFacExportFields: ExportFieldOption[] = [
  { value: "job_title", label: "Job Title" },
  { value: "job_seniority", label: "Job Seniority" },
  { value: "job_function", label: "Job Functions" },
  { value: "job_sub_function", label: "Job Sub-Functions" },
  { value: "employment_start_date", label: "Employment Start Date" },
  { value: "time_in_role_months", label: "Time in Company (Months)" },
  { value: "contact_location_city", label: "City" },
  { value: "contact_location_region", label: "State" },
  { value: "contact_location_country", label: "Country" },
  { value: "contact_location_country_code", label: "Country Code" },
  { value: "first_name", label: "First Name" },
  { value: "last_name", label: "Last Name" },
  { value: "full_name", label: "Full Name" },
  { value: "linkedin_url", label: "LinkedIn URL" },
  { value: "work_email", label: "Work Email" },
  { value: "mobile_phone", label: "Mobile Phone" },
  { value: "product_name", label: "Product" },
  { value: "product_id", label: "Product ID" },
  { value: "product_description", label: "Product Description" },
  { value: "vendor_name", label: "Vendor" },
  { value: "vendor_domain", label: "Vendor Domain" },
  { value: "vendor_id", label: "Vendor ID" },
  { value: "product_category_id", label: "Product Category ID" },
  { value: "product_category_level1_name", label: "Category Level 1" },
  { value: "product_category_level2_name", label: "Category Level 2" },
  { value: "product_category_level3_name", label: "Category Level 3" },
  { value: "product_category_level4_name", label: "Category Level 4" },
  { value: "product_category_level5_name", label: "Category Level 5" },
  { value: "product_attributes", label: "Product Attributes" },
  { value: "product_first_verified_date", label: "First Verified" },
  { value: "product_last_verified_date", label: "Last Verified" },
];

export const financingEventsExportFields: ExportFieldOption[] = [
  { value: "id", label: "Event ID" },
  { value: "effective_date", label: "Effective Date" },
  { value: "found_at", label: "Discovered Date" },
  { value: "categories", label: "Categories" },
  { value: "financing_type", label: "Financing Type" },
  { value: "amount_normalized", label: "Amount" },
  { value: "source_urls", label: "Source URLs" },
  { value: "investor_company_name_array", label: "Investor Names" },
  { value: "investor_domain_name_array", label: "Investor Domains" },
  { value: "investor_hg_company_id_array", label: "Investor HG Company IDs" },
];

// Values match covered-wagon's mergers_acquisitions field definitions.
export const mergersAcquisitionsExportFields: ExportFieldOption[] = [
  { value: "id", label: "Event ID" },
  { value: "headline", label: "Headline" },
  { value: "summary", label: "Summary" },
  { value: "category", label: "Category" },
  { value: "effective_date", label: "Effective Date" },
  { value: "found_at", label: "Discovered Date" },
  { value: "article_sentence", label: "Article Sentence" },
  { value: "confidence", label: "Confidence" },
  { value: "amount_normalized", label: "Amount" },
  { value: "news_source_url", label: "News Source URL" },
  { value: "country", label: "Country" },
  { value: "region", label: "Region" },
  { value: "continent", label: "Continent" },
  { value: "actee_hg_company_id", label: "Actee HG Company ID" },
  { value: "actee_company_name", label: "Actee Company Name" },
  { value: "actee_domain_name", label: "Actee Domain" },
];

export const defaultFirmographicsFields: string[] = firmographicsExportFields
  .map((f) => f.value)
  .filter(
    (v) =>
      v !== "relative_employees" &&
      v !== "relative_revenue" &&
      v !== "company_description"
  );

export const defaultTimeSeriesFields: string[] = [
  "hg_id",
  "product_id",
  "date_verified",
  "weighted_score",
];

export const defaultMentionTimeSeriesFields: string[] = [
  "hg_id",
  "mention_id",
  "date_verified",
  "weighted_score",
];
